import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { fromJS, Record } from 'immutable';

export const XERO_ACCOUNT_CODE_SCHEMA = Object.freeze({
  CODE: '',
  NAME: '',
  STATUS: '',
  TYPE: '',
  TAX_TYPE: '',
});

const RECORD = generateSchema(XERO_ACCOUNT_CODE_SCHEMA);
const KEYS: any = generateKeys(XERO_ACCOUNT_CODE_SCHEMA);

export class XeroAccountCode extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get code(): string {
    return this.get(KEYS.CODE);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get status(): string {
    return this.get(KEYS.STATUS);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get taxType(): string {
    return this.get(KEYS.TAX_TYPE);
  }
}
